var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo-competo",attrs:{"src":"/img/COMPETO_LOGO_2024_white.svg","alt":"Competo Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }